import { createSlice, isAction } from "@reduxjs/toolkit";
import { fetchInStocks } from "./thunk";

interface InStockState {
  InStockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedInStockTask: any;
}

const initialState: InStockState = {
  InStockList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedInStockTask: null,
};

const InStockSlice = createSlice({
  name: "InStockTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInStocks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInStocks.fulfilled, (state, action) => {
        state.loading = false;
        state.InStockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInStocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch InStockTasks";
      });
  },
});

export default InStockSlice.reducer;
